<template>
  <p class="body m-0 mb-1">
    <strong>{{ t('reservations.reference') }}:</strong>
    {{ reference }}
  </p>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  // Props
  defineProps({
    reference: {
      type: String,
      required: true,
    },
  })

  // i18n instance
  const { t } = useI18n()
</script>

<style></style>
